module.exports = __webpack_public_path__ + "static/media/royal_gaming.dc75ab8a.webp";